import React from 'react';
import { ColContainer, Typography } from '../../../components/common';

export const ScheduleCells = ({ dayItinerary, routingProfiles, instances, dayEnd }) => {
    const cells = dayItinerary.map((item) => {
        const routingProfile = routingProfiles.find((i) => i.Id === item.routingprofileid);
        const routingProfileName = routingProfile?.Name || 'Missing Routing Profile Name';

        const instanceId = routingProfile?.Arn.split('/')[1];
        const instance = instances?.find((i) => i.Id === instanceId) || {
            project: '',
            company: '',
        };

        const standardValues = {
            label: routingProfileName,
            project: instance.project,
            company: instance.company,
            schedule: item.schedulename,
            acw: item.acw,
            autoaccept: item.autoaccept,
        };

        const nextItem = dayItinerary.find((i) => i.time > item.time);

        if (nextItem)
            return {
                start: item.time,
                end: nextItem.time,
                colSpan: (nextItem.time - item.time) / 15,
                ...standardValues,
            };

        return {
            start: item.time,
            end: dayEnd,
            colSpan: (dayEnd - item.time) / 15,
            ...standardValues,
        };
    });

    return cells.map((item, index) => <TableCell key={index} item={item} />);
};

export const PrevDayLatestCell = ({
    routingProfiles,
    instances,
    dayItinerary,
    itinerary,
    dayStart,
    dayEnd,
    todaysDayNumber,
}) => {
    const prevDayItem = itinerary
        .filter((i) => i.day === todaysDayNumber - 1 && i.time >= dayStart && i.time < dayEnd)
        .sort((i) => i.time)
        .pop();

    const routingProfile = prevDayItem
        ? routingProfiles.find((i) => i.Id === prevDayItem.routingprofileid)
        : null;
    const routingProfileName = routingProfile?.Name || '';

    const instanceId = routingProfile?.Arn.split('/')[1];
    const instance = instances?.find((i) => i.Id === instanceId) || {
        project: '',
        company: '',
    };

    const minEntry = Math.min(...dayItinerary);
    const emptyCells = (minEntry - dayStart) / 15;

    const prevDayItemObject = {
        start: prevDayItem?.time || dayStart,
        end: minEntry,
        colSpan: emptyCells,
        label: routingProfileName,
        project: instance.project,
        company: instance.company,
        schedule: prevDayItem?.schedulename,
        acw: prevDayItem?.acw,
        autoaccept: prevDayItem?.autoaccept,
    };

    return <TableCell key={'empty_1'} item={prevDayItemObject} />;
};

const TableCell = ({ item }) => {
    return (
        <td
            colSpan={item?.colSpan}
            data-start={item?.start}
            data-end={item?.end}
            data-for="table"
            data-tip={JSON.stringify(item)}
            style={{ borderLeft: '3px solid #A4DEFF' }}
            className="overflow-hidden truncate whitespace-nowrap border border-table-border pl-2 text-center"
        >
            <ColContainer>
                <Typography variant="heading2.2">
                    {item?.company} ({item?.project})
                </Typography>
                <Typography variant="body3">
                    {item?.label}, ACW of {item?.acw} (seconds),{' '}
                    {item?.autoaccept ? 'Auto' : 'Manual'} accept
                </Typography>
            </ColContainer>
        </td>
    );
};
